export default __webpack_public_path__ + "static/media/craon.e31d003a.jpg";